<section class="cage-details">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h2 class="my-4 text-primary">Cage Detail</h2>
      </div>
      <div class="col-12">
        <div class="cage-details-inner rounded-4 p-4 bg-light">
          <div class="bg-white p-4 rounded-4">
            <div class="row">
              <div class="col-lg-6">
                <div class="overflow-hidden swiper-main-box">
                  <div class="swiper-container position-relative gallery-top" #swiperContainer>
                    <div class="swiper-wrapper">
                      @for (slide of slides; track $index) {
                      <div class="swiper-slide">
                        <img [src]="slide?.img" />
                      </div>
                      }
                    </div>
                  </div>
                  <div class="swiper-container gallery-thumbs mt-3">
                    <div class="swiper-wrapper">
                      @for (slide of slides; track $index) {
                      <div class="swiper-slide">
                        <img [src]="slide?.img" />
                      </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-6 mt-5 mt-lg-0">
                <div class="cabin-detail px-3">
                  <h3 class="text-primary mb-4">
                    {{ cageTypeGrid?.title | titlecase }}
                  </h3>

                  @if (cageTypeGrid?.review?.total_review > 0) {
                  <p>
                    <app-star-rating [maxScore]="5" [score]="cageTypeGrid?.review?.ratting" [forDisplay]="true">
                    </app-star-rating>&nbsp;({{ cageTypeGrid?.review?.total_review }})
                  </p>
                  }
                  <ul class="cabin-detail-list">
                    <li class="d-flex justify-content-between flex-column flex-md-row">
                      <span class="type-name">Cage size:</span><span class="type-value">{{ cageTypeGrid?.width }} x
                        {{ cageTypeGrid?.height }} x {{ cageTypeGrid?.length }}
                        {{ cageTypeGrid?.unit }}</span>
                    </li>
                    <li class="d-flex justify-content-between flex-column flex-md-row">
                      <span class="type-name">Cage Price:</span><span class="type-value">{{ cageTypeGrid?.amount |
                        currency }}/day</span>
                    </li>
                    <li class="d-flex justify-content-between flex-column flex-md-row">
                      <span class="type-name">Maximum number of pets:</span>
                      <span class="type-value">{{
                        cageTypeGrid?.allow_pet_number
                        }}</span>
                    </li>
                    <li class="d-flex justify-content-between flex-column flex-md-row">
                      <span class="type-name">Suitable For</span><span class="type-value">
                        @for (pet of cageTypeGrid?.pet_types; track $index) {

                        <span class="type-repeter">
                          @if ( $index != 0) {
                          <span>, </span>
                          }
                          {{ pet?.title | titlecase }}
                        </span>

                        }
                      </span>
                    </li>
                    <li class="list-full-width">
                      <span class="type-name">Description:</span>

                      @if (cageTypeGrid?.description) {
                      <span class="type-value" [innerHTML]="cageTypeGrid?.description"></span>
                      }@else {
                      <span class="type-value">N/A</span>
                      }
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="d-flex flex-column justify-content-end mt-5">
                <ul class="d-flex justify-content-center justify-content-md-end">
                  <li class="me-3">
                    <a href="javascript:void(0)" class="btn btn-outline-success" (click)="backToCageList()"><span
                        class="left-icon left-arrow">Back</span></a>
                  </li>
                  <li>
                    <a href="javascript:void(0)" class="btn btn-success"
                      (click)="bookCage(cageTypeGrid,dateSelectionModal)" [ngClass]="{
                        disabled: !cageTypeGrid?.is_available_for_outpost
                      }"><span class="left-icon tick-icon">Book Now</span></a>
                  </li>
                </ul>
                @if (!cageTypeGrid?.is_available_for_outpost) {
                <div class="bottom-link ms-auto mt-3 mb-2">
                  <a href="javascript:void(0)" (click)="onSelect(cageTypeGrid.id)"><u class="fw-bold">Click
                      Here</u></a>
                  and change Center to continue with this Cage.
                </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Select new cage Modal -->

<ng-template #dateSelectionModal let-modal>
  <div class="modal-header">
    <h5 class="text-info" id="exampleModalLongTitle">
      Select Check-In and Check-Out dates
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <div class="form-inner">
      <form action="#" class="modal-availability-inner">
        <div class="row">
          <div class="col-md-6">
            <label class="form-label label-large">Check-In Date</label>
            <p-calendar class="form-control p-0" placeholder="Select check-in date" [(ngModel)]="inwardDate"
              (click)="addClassOnDatePicker()" [appendTo]="'body'" [minDate]="minInWardDate" [maxDate]="maxDate"
              [dateFormat]="pCalendarDateFormat" (onSelect)="selectInwardDate()" [ngModelOptions]="{ standalone: true }"
              [readonlyInput]="true" hideOnDateTimeSelect="true" [showIcon]="true" styleClass="p-calendar">
              <ng-template pTemplate="date" let-date>
                <span [ngStyle]="{
                    backgroundColor: getSelectedDays(date)
                      ? '#005b9f'
                      : 'inherit',
                    color: getSelectedDays(date) ? 'white' : 'inherit'
                  }" class="selected-inward">{{ date.day }}</span>
              </ng-template>
            </p-calendar>
            @if (submitted && !inwardDate) {
            <span class="text-danger error">Please select Check-In date</span>
            }
          </div>
          <div class="col-md-6">
            <label class="form-label label-large">Check-Out Date</label>
            <p-calendar class="form-control p-0" placeholder="Select check-out date" #checkout [disabled]="!inwardDate"
              (click)="addClassOnDatePicker()" [appendTo]="'body'" [(ngModel)]="outwardDate" [minDate]="inwardDate"
              [dateFormat]="pCalendarDateFormat" (onSelect)="selectOutwardDate()" [readonlyInput]="true"
              [ngModelOptions]="{ standalone: true }" [showIcon]="true" styleClass="p-calendar">
              <ng-template pTemplate="date" let-date>
                <span [ngStyle]="{
                    backgroundColor: getSelectedDays(date)
                      ? '#005b9f'
                      : 'inherit',
                    color: getSelectedDays(date) ? 'white' : 'inherit'
                  }" class="selected-outward">{{ date.day }}</span>
              </ng-template>
            </p-calendar>
            @if (submitted && !outwardDate) {
            <span class="text-danger error">Please select Check-Out date</span>
            }
          </div>
        </div>
      </form>
      <label class="text-danger error text-center" [hidden]="!isCageUnavailable">Sorry this cage is not available
        for selected dates</label>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-success next" (click)="checkCageAvailability()" type="button">
      <span>Continue</span>
    </button>

  </div>
</ng-template>